import { FC, useCallback, useEffect } from 'react';
import { Onfido } from 'onfido-sdk-ui';
import { useGetVerificationTokenQuery } from 'entities/account/api';
import { EMI } from 'shared/model/types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useStartVerificationMutation } from 'pages/dashboard/api';
import { useSaveGtagMutation } from 'entities/user/api';
import { GTAG_ID } from 'shared/const/app';

type Props = {
  onComplete: () => unknown;
  closeVerificationModal: () => unknown;
  emi: EMI;
};

export const OnfidoVerification: FC<Props> = ({ onComplete, emi, closeVerificationModal }) => {
  const { data, isLoading } = useGetVerificationTokenQuery({ emi: emi });
  const [startVerificationApi] = useStartVerificationMutation();
  const [saveGtag] = useSaveGtagMutation();

  const initOnfido = useCallback(() => {
    if (data) {
      const onfidoInstance = Onfido.init({
        token: data?.response.token,
        containerId: 'onfido-container',
        steps: [
          {
            type: 'document',
            options: {
              documentTypes: {
                residence_permit: true,
                passport: true,
                national_identity_card: true
              }
            }
          },
          'face'
        ],
        theme: {
          name: 'light'
        },
        onComplete: async (data) => {
          console.log(data);
          await startVerificationApi(emi);
          onComplete();
          
          gtag('get', GTAG_ID, 'client_id', (clientID) => {
            saveGtag({ clientId: clientID as string, eventName: 'web_kyc_verification_completed', gtag: GTAG_ID });
            gtag('event', 'web_kyc_verification_completed', {
              provider: 'Onfido',
              emi: EMI.Wallester,
            });
          });
        },
        onError: (error) => {
          console.log(error);
        }
      });

      return onfidoInstance;
    }
  }, [data]);

  useEffect(() => {
    console.log(data);
    initOnfido();
    return () => {
      initOnfido()?.tearDown();
    };
  }, [initOnfido, data]);

  if (isLoading) {
    return <Spin indicator={<LoadingOutlined spin />} size='large' />;
  }

  return <div id='onfido-container'></div>;
};
